import { Component, input } from '@angular/core';
import { BaseConfig } from '../common/config/config.adapter';

@Component({
  selector: 'lepi-text-field',
  standalone: true,
  template: `
    <div class="flex flex-col gap-1.5 py-1.5 group">
      <span class="text-xs text-base-content/50 font-medium tracking-tight">
        {{ label() }}
      </span>
      <div
        class="text-sm text-base-content leading-relaxed border-l-2 border-primary/30 pl-3">
        <ng-content />
      </div>
    </div>
  `,
  imports: [],
})
export class TextField extends BaseConfig {
  label = input.required<string>();
  required = input<boolean>(false);
}
